
export const ANALYTICS_ITEM_LIST_CONSTANTS = {
  SEARCH: 'Search Results',
  CAROUSEL: 'Product Carousel',
  FAVOURITES: 'Favourites',
  CATEGORY: 'Category',
  EINSTEIN: 'Einstein'
}